module.exports = __webpack_public_path__ + "assets/img/logo.a244b487.png";